<template>
    <v-card-text class="py-2">
        <v-row>
            <v-col cols="12" class="pb-0">
                <span class="pt-2 text-body-1 font-weight-bold text-uppercase">{{ $t('order') }}&nbsp;Agrolink</span>
            </v-col>
            <v-col cols="12"
                   v-for="(order, idx) in orders"
                   :key="idx"
            >
                <order-amount-row
                    :order="order"
                ></order-amount-row>
            </v-col>
        </v-row>
        <v-row class="px-1">
            <v-col cols="5" >
                <span class="text-body-1 text-uppercase font-weight-thin">{{ $t('toPay') }}:</span>
            </v-col>
            <v-col cols="7" class="text-right d-flex justify-end flex-wrap">
                <span class="text-body-1 font-weight-black">{{ formatCommonSum }}</span>&nbsp;
                <span class="text-lowercase text-body-1 font-weight-black">{{currency.cyrName}}</span>
            </v-col>
        </v-row>
        <v-row v-if="hasLiqpayCommission" class="text-body-1 font-italic">
            <v-col cols="7" class="text-right d-flex justify-end flex-wrap pt-0">
                <span>+ {{ $t('commission') }} ({{liqpayCommission * 100}}%)</span>
            </v-col>
            <v-col cols="5" class="text-right d-flex justify-end flex-wrap pt-0">
                <span>{{ formatLiqpayCommissionSum }}</span>&nbsp;
                <span class="text-lowercase">{{currency.cyrName}}</span>
            </v-col>
        </v-row>
        <v-row class="mx-5">
            <v-divider></v-divider>
        </v-row>
    </v-card-text>
</template>

<script>
import OrderAmountRow from './OrderAmountRow'
import OrderDataProvider from "../../../../app-front/mixins/OrderDataProvider";
import numberFormat from "../../../../utils/numberFormat";

export default {
    name: "AgrolinkAmount",
    components: { OrderAmountRow },
    mixins: [ OrderDataProvider ],
    props: [ 'orders' ],
    computed: {
        currency() {
            return this.$store.getters.currencies.find(item => item.id === 1)
        },
        liqpayCommission() {
            return this.$store.getters.liqpayCommission;
        },
        commonSum() {
            return this.orders.reduce((sum, item) => {
                const inProcessOrder = this.inProcessProducts.find(order => order.sellerID === item.seller.id)
                const curVal = inProcessOrder.priceWithDiscount ? inProcessOrder.priceWithDiscount : inProcessOrder.priceSummary;
                return sum + curVal
            }, 0);
        },
        formatCommonSum() {
            return numberFormat(this.commonSum, '2', '.', ' ')
        },
        liqpayCommissionSum() {
            return this.commonSum * this.liqpayCommission;
        },
        formatLiqpayCommissionSum() {
            return numberFormat(this.liqpayCommissionSum, '2', '.', ' ');
        },
    }
}
</script>

<style scoped>

</style>
